import React from 'react';
import BaseText from '../../ui/typography/BaseText';
import { StaticImage } from 'gatsby-plugin-image';
import Cloud from '../../../images/inline/cloud.inline.svg';
import Contract from '../../../images/inline/contract.inline.svg';
import Library from '../../../images/inline/library.inline.svg';
import Tools from '../../../images/inline/tools.inline.svg';
const SecuredDashboard = () => {
  return (
    <div className="global-max-width-wrapper mx-auto flex md:flex-row flex-col items-center mt-28 mb-12">
      <div>
        <div className="ml-8 mb-4 flex flex-col gap-1 items-center">
          <div className="flex items-center gap-2">
            <figure className="mb-4 mr-2 text-center">
              <Cloud />
            </figure>
            <BaseText fontWeight="text-bold" className="mb-4" title="Secured Online Dashboard" />
          </div>
          <ul className="mb-4 text-xs ml-2">
            <li>- Access your company documents 24/7</li>
            <li>- Manage your company online</li>
          </ul>
        </div>
        <StaticImage src="../../../images/homePageImages/dashboard.png" alt="dashboard" loading="lazy" />
      </div>

      <div className="ml-8 secured">
        <div className="flex items-center gap-2">
          <figure className="mb-4 mr-2 text-center">
            <Contract />
          </figure>
          <BaseText fontWeight="text-bold" className="mb-4" title="Sales" />
        </div>
        <ul className="mb-4 flex flex-col gap-1 text-xs ml-8">
          <li>- Business Plan Template</li>
          <li>- Sales Invoice (HK compliant)</li>
          <li>- Template Sales Quote (HK compliant)</li>
          <li className="flex gap-1">
            - Freelance Invoice (HK compliant)
            <div className="bg-blue-500 px-1 rounded">
              <BaseText title="New" textColor="text-white" fontSize="8px" fontWeight="text-bold" />
            </div>
          </li>
          <li>- Service Invoice (HK compliant)</li>
          <li>- Proforma Invoice (HK compliant)</li>
          <li className="flex gap-1">
            - Commercial Invoice (HK compliant)
            <div className="bg-blue-500 px-1 rounded">
              <BaseText title="New" textColor="text-white" fontSize="8px" fontWeight="text-bold" />
            </div>
          </li>
          <li>- VAT Invoice</li>
        </ul>

        <div className="flex items-center gap-2">
          <figure className="mb-4 mr-2 text-center mt-12">
            <Library />
          </figure>
          <BaseText fontWeight="text-bold" className="mb-4 mt-12" title="Contracts" />
        </div>

        <ul className="mb-4 flex flex-col gap-1 text-xs ml-8">
          <li className="flex gap-1">
            - Confidentiality Agreement{' '}
            <div className="bg-blue-500 px-1 rounded">
              <BaseText title="New" textColor="text-white" fontSize="8px" fontWeight="text-bold" />
            </div>
          </li>
          <li>- Service Agreement</li>
          <li>- Consulting Agreement</li>
          <li>- Terms of Use</li>
          <li>- Privacy Policy</li>
          <li>- Shareholders Agreement</li>
          <li>- Letter of Employment</li>
          <li className="flex gap-1">
            - Sales Commission Agreement{' '}
            <div className="bg-blue-500 px-1 rounded">
              <BaseText title="New" textColor="text-white" fontSize="8px" fontWeight="text-bold" />
            </div>
          </li>
        </ul>

        <div className="flex items-center gap-2">
          <figure className="mb-4 mr-2 text-center mt-12">
            <Tools />
          </figure>
          <BaseText fontWeight="text-bold" className="mb-4 mt-12" title="Management" />
        </div>

        <ul className="mb-4 text-xs ml-8">
          <li>- Digital Company Chops</li>
          <li>- Template Board Resolutions</li>
          <li className="flex gap-1">
            - Template Shareholders Resolutions{' '}
            <div className="bg-blue-500 px-1 rounded">
              <BaseText title="New" textColor="text-white" fontSize="8px" fontWeight="text-bold" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SecuredDashboard;
